<template>
  <div>
    <Counting_stock_list/>
  </div>
</template>

<script>
import Counting_stock_list from "@/components/adminArin/pos_system/warehouse/countingstock/Counting_stock_list";
export default {
  name: "countingstocklist",
  components: {
    Counting_stock_list
  }
}
</script>

<style scoped>

</style>
